<template>
    <div>Dashboard</div>
</template>
<script>
export default {
    name: 'DashBoard',
    data: () => ({
    })
}
</script>